import { Heading, Box, Text, Image } from '@dapperlabs/core-fe';
import React from 'react';

interface Props {
  cardHeading: string;
  cardImgSrc: string;
  cardText: string;
  textGradientColor: string;
}

export const RarityCard: React.FC<Props> = ({
  cardHeading,
  cardText,
  cardImgSrc,
  textGradientColor,
}) => {
  return (
    <>
      <Image
        boxSize={291}
        maxWidth={['fit-content', 'fit-content', 'fit-content', '100%']}
        borderRadius='16px'
        alt={cardHeading}
        src={cardImgSrc}
      />
      <Box padding='1.5rem 2rem'>
        <Heading
          as='h3'
          fontSize='1.125rem'
          background={textGradientColor}
          backgroundClip='text'
        >
          {cardHeading}
        </Heading>
        <Text pt={2} fontSize={['sm', 'sm', 'lg']}>
          {cardText}
        </Text>
      </Box>
    </>
  );
};
